import { ValidationTrigger, createManagerFactory, formBuilder } from 'app-components/utils/createForm/formBuilder';
import { createFormHooks } from 'app-components/utils/createForm/formHooks';

// TODO: replace with real QCS filing statuses when available
export const filingStatuses = [
  'SINGLE',
  'MARRIED_FILING_JOINTLY',
  'MARRIED_FILING_SEPARATELY',
  'HEAD_OF_HOUSEHOLD',
  'SURVIVING_SPOUSE',
] as const;
export type FilingStatus = (typeof filingStatuses)[number];
type FormData = {
  filingStatus?: FilingStatus;
  denendents?: number;
  selfWages?: number;
  spouseWages?: number;
};
const init = ({ input }: { input: FormData; store?: any }) => {
  const initialValue = {
    ...input,
  };
  return initialValue;
};

export const formFactory = createManagerFactory(
  formBuilder({ init })
    .addField('filingStatus', {
      selector: (state) => state.filingStatus || undefined,
      onValueChange: (draft, value: FilingStatus | undefined) => {
        draft.filingStatus = value;
      },
      validation: {
        required: {
          triggers: ValidationTrigger.onSubmit | ValidationTrigger.onChange,
          isValid: (state) => Boolean(state?.filingStatus && filingStatuses.includes(state?.filingStatus)),
          error: () => 'please select filing status',
        },
      },
    })
    .addField('denendents', {
      selector: (state) => state.denendents || 0,
      onValueChange: (draft, value: number) => {
        draft.denendents = value;
      },
      validation: {
        required: {
          triggers: ValidationTrigger.onSubmit | ValidationTrigger.onChange,
          isValid: (state) => !Number.isNaN(Number(state?.denendents)) && (state?.denendents || 0) >= 0,
          error: () => 'please enter a value of 0 or greater',
        },
      },
    })
    .addField('selfWages', {
      hiddenSelector: (state) => state.selfWages === undefined,
      selector: (state) => state.selfWages,
      onValueChange: (draft, value: number | undefined) => {
        draft.selfWages = value;
      },
      validation: {
        required: {
          triggers: ValidationTrigger.onSubmit | ValidationTrigger.onChange,
          isValid: (state) =>
            state?.selfWages === undefined || (!Number.isNaN(Number(state?.selfWages)) && (state?.selfWages || 0) >= 0),
          error: () => 'please enter a value of 0 or greater',
        },
      },
    })
    .addField('spouseWages', {
      hiddenSelector: (state) => state.spouseWages === undefined || state.filingStatus !== 'MARRIED_FILING_JOINTLY',
      selector: (state) => state.spouseWages,
      onValueChange: (draft, value: number | undefined) => {
        draft.spouseWages = value;
      },
      validation: {
        required: {
          triggers: ValidationTrigger.onSubmit | ValidationTrigger.onChange,
          isValid: (state) =>
            state?.spouseWages === undefined ||
            (!Number.isNaN(Number(state?.spouseWages)) && (state?.spouseWages || 0) >= 0),
          error: () => 'please enter a value of 0 or greater',
        },
      },
    })
    .build({
      submitTransform: (state) => state,
    }),
);

export const {
  FormProvider,
  InternalFormProvider,
  useField,
  useMultiFields,
  useIsDirty,
  useIsFormValid,
  useSelector,
  useManager,
} = createFormHooks(formFactory);
